import { Image, ImageList } from "@/components/Elements";
import { useReportContentMutation } from "@/services/modules/post";
import { useLikeDislikeCommentMutation } from "@/services/modules/postComment";
import { selectComment } from "@/store/postComment";
import { RootState } from "@/store/reducers";
import { PostCommentModel } from "@/types/post";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import PostAction from "../../../misc/components/PostAction";
import { PotsActionType } from "../../types";
import TranslatedPostComment from "../../../misc/components/TranslatedPostComment";

function Comment({
  commentDetail,
  hasChildren,
  hasSibling,
}: {
  commentDetail: PostCommentModel;
  hasChildren: boolean;
  hasSibling: boolean;
}) {
  const {
    userName: createdBy,
    userId,
    userImageUrl: createdByImgUrl,
    createdOn,
    comment,
    likeStatus,
    dislikeStatus,
    postCommentId,
    postId,
    parentId,
    files,
  } = commentDetail;
  const [likeDislikeComment] = useLikeDislikeCommentMutation();
  const [reportContent] = useReportContentMutation();
  const dispatch = useDispatch();
  const currentUserId = useSelector(
    (state: RootState) => state.login.userDetail.userId
  );
  const [translatedText, setTranslatedText] = useState("");
  // const [deleteComment] = useDeleteCommentMutation();

  const handleLikeDislike = (like: boolean = false) => {
    likeDislikeComment({
      commentId: postCommentId,
      postId,
      like,
      status: like ? !likeStatus : !dislikeStatus,
    });
  };

  const handleReply = () => {
    dispatch(selectComment(commentDetail));
  };

  const handleReport = (reasonId: string) => {
    reportContent({
      reasonId,
      postId,
      postCommentId,
    });
  };

  // const handleDelete = () => {
  //   deleteComment(postCommentId);
  // };

  return (
    <>
      <div className="relative flex-1">
        {hasChildren && (
          <div
            className={`border absolute border-[#d3d3d3] h-full top-0 left-[25px]`}
          />
        )}
        {parentId && (
          <>
            <div
              className={`border border-[#d3d3d3] absolute left-[-25px] h-[25px] top-0`}
            />
            <div
              className={`border border-[#d3d3d3] absolute left-[-25px] w-[25px] top-[25px]`}
            />
          </>
        )}
        {hasSibling && (
          <div
            className={`border border-[#d3d3d3] absolute left-[-25px] h-full top-0`}
          />
        )}
        <div className="flex">
          <div
            className={`border rounded-[50px] border-[#d3d3d3] bg-[#ffffff] w-[50px] h-[50px] p-[1px] z-0`}
          >
            <Image src={createdByImgUrl} isApiUrl className="w-full h-full" />
          </div>
          <div className="m-1 flex-1">
            <div className={`bg-[#f1f2f6] p-2 rounded-2xl flex-1 flex-grow`}>
              <div className="flex justify-between">
                <div className="font-bold text-[16px]">{createdBy}</div>
                <PostAction
                  type={PotsActionType.Comment}
                  handleReport={handleReport}
                  translateText={comment}
                  handleTranslate={setTranslatedText}
                  showReportContent={userId != currentUserId}
                />
              </div>
              <div className="text-[12px] text-[#9c9d9e] flex-1 flex-shrink">
                {comment}
              </div>
              <TranslatedPostComment
                translatedText={translatedText}
                handleTranslate={setTranslatedText}
              />
              <ImageList files={files} />
            </div>
            <div className="flex ml-[10px] mb-[10px]">
              <div className="mr-[20px]">
                <div className="text-[14] text-[#626367]">{createdOn}</div>
              </div>
              <div
                onClick={() => handleLikeDislike(true)}
                className="mr-[20px]"
              >
                <div className="text-[14px] text-[#626367]">
                  {likeStatus ? "Unlike" : "Like"}
                </div>
              </div>
              <div onClick={handleReply} className="mr-[20px]">
                <div className="text-[14px] text-[#626367]">Reply</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`ml-[50px]`}>
        <CommentList parentId={postCommentId} postId={postId} />
      </div>
    </>
  );
}

function CommentList({
  postId,
  parentId,
}: {
  postId: number;
  parentId?: number;
}) {
  const commentList = useSelector(
    (state: RootState) => state.postComment.commentList
  );
  const data = commentList.filter((c) => c.parentId == parentId);

  return (
    <>
      {data.map((item, index) => (
        <Comment
          key={item.postCommentId}
          commentDetail={item}
          hasChildren={commentList.some(
            (s) => s.parentId == item.postCommentId
          )}
          hasSibling={index < data.length - 1}
        />
      ))}
    </>
  );
}

export default CommentList;
